// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__390Im","right":"styles_right__37Ll9"};